document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.getElementById('mobileToggle')
  const menu = document.getElementById('mobileMenu')

  if (!toggle || !menu) return

  const open = () => {
    menu.classList.add('open')
    toggle.classList.add('open')
    toggle.setAttribute('aria-expanded', 'true')
    menu.setAttribute('aria-hidden', 'false')
  }

  const close = () => {
    menu.classList.remove('open')
    toggle.classList.remove('open')
    toggle.setAttribute('aria-expanded', 'false')
    menu.setAttribute('aria-hidden', 'true')
  }

  toggle.addEventListener('click', () => {
    menu.classList.contains('open') ? close() : open()
  })

  for (const link of menu.querySelectorAll('a')) {
    link.addEventListener('click', close)
  }
})
